import { SerializedEditorState } from "lexical";
import { z } from "zod";

// This is a no-op stub to add typing to the MessageContent type.
function mockIsSerializedEditorState(x: any): x is SerializedEditorState {
  return true;
}

export const MessageContentSchema = z.object({
  error_message: z.string().optional(),
  subject: z.string().optional(),
  email_lexical: z.any().refine(mockIsSerializedEditorState).optional(),
  sms_lexical: z.any().refine(mockIsSerializedEditorState).optional(),
  language: z.string(),
  language_name: z.string(),
});

export type MessageContent = z.infer<typeof MessageContentSchema>;

export const MessageFormSchema = z.object({
  messages: z.array(MessageContentSchema),
  email_attachments: z.array(z.instanceof(File)).optional(),
});

export type MessageFormType = z.infer<typeof MessageFormSchema>;

export const PreviewDrawerFormSchema = z.object({
  messages: z.array(MessageContentSchema),
});

export type PreviewDrawerFormType = z.infer<typeof PreviewDrawerFormSchema>;
